import * as React from 'react';
import { observer, inject } from 'mobx-react';
import PackageLinesTextBlocksGrid from '../components/PackageLinesLabelsGrid';
import FlexContentContainer from '../../common/components/FlexContentContainer';
import { ListTextBlocksStores } from '../stores';
import { STORE_PROJECT_TEXT_BLOCKS } from '../constants';

type Props = ListTextBlocksStores;

@inject(STORE_PROJECT_TEXT_BLOCKS)
@observer
export default class TextBlocksPage extends React.Component<Props, object> {
    render() {
        return <FlexContentContainer content={<PackageLinesTextBlocksGrid />} />;
    }
}
